

import { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../store/hooks/redux";
import { setBase64File, setCardsCount, setCardTimeProgress, setDefects, setDeviations, setIdentCardInfo, setMedCardInfo, setMedicalReport, setNorms } from "./MedExamsSlice";
import { finishCardRequest, getCardByDriver, getCardForMedicRequest, getCardsCount, getDocumentForMedicRequest, getFaceProcessingTask, getMedicCardRequest, getNormsRequest, setMedicWorkStatusRequest, signCardRequest, updateCardRequest, updateDocumentRequest } from '../../services/DriverCardService';
import { CardType, IDeviation, IDriver, IMedCard, IMedTableData, IMedicalReport, INorm, INormTable, IReportStatus, IdentCard, IdentCardStatus, MedCardStatuses, NormCodes } from "./types";
import { setIsActive } from "../../slices/CommonInfoSlice";
import { ICertificate, createSign, getUserCertificate } from "../../services/cryptoService";
import { createFileFromBase64, createFileRequest, createTitle, getBase64FileRequest, getBufferFileRequest, getVideoBlobSrc } from "../../services/fileService";
import { getUserCertificates } from "crypto-pro";
import { useModal } from "../../modules/layout/components/modals/useModal";
import { ModalNames, setCurrentApiUrl } from "../../slices/AppSlice";
import { Buffer } from "buffer";
import { $file } from "../../api";
import moment from "moment";
import sanitizedConfig from "../../Config";
import { sign } from "crypto";
// import { writeFileSync } from "data:fs";




export const getTableDataFromCard = (card: IMedCard | null) => {

    if (card !== null) {
        const {
            systolic_pressure,
            diastolic_pressure,
            pulse_rate,
            temperature,
            alcohol_content,
            full_url,
            type,
            driver_health_reports
        } = card
        const data: IMedTableData = {
            currentSystolicPressure: systolic_pressure,
            currentDiastolicPressure: diastolic_pressure,
            currentPulseRate: pulse_rate,
            currentTemperature: temperature,
            currentAlcoholContent: alcohol_content,
            fullUrl: full_url,
            type: type,
            driverHealthReports: driver_health_reports
        }
        return data
    } else return null
}


const updateCard = async (api_url: string, id: number, data: IMedCard) => {
    try {
        const response = await updateCardRequest(api_url, id, data);
        console.log('updated response')
        console.log(response)
        const updatedData = response.data;
        return updatedData;
    } catch (e) {
        console.log(e)
    }
}

const getSignUrl = async (api_url: string, certificate_value: any, buffer: any,) => {
  const bufferFile = Buffer.from(buffer)
  const signature = await createSign(certificate_value, bufferFile)
  if (signature) {
    const bufferSignature = new Blob([Buffer.from(signature)])
    const formData = new FormData()
    formData.append('file', bufferSignature, 'sign.sgn')
    return (await createFileRequest(formData, api_url))?.data?.link
  } else return false
}


export const setConclusion = async (api_url: string, card: IMedCard | null, medicalReport: IMedicalReport, medicId: number, certificate:ICertificate) => {
    const timings = { timingsMedic: { ...card?.timings.timingsMedic, resolutionSignedAt: moment().format('YYYY-MM-DDTHH:mm:ss') + 'Z' } }
    try {
        delete certificate.id
        const sing = (await signCardRequest(api_url, card?.id!, {
          medical_report: medicalReport,
          certificate: certificate,
        }))?.data
        if (!sing) throw new Error(ModalNames.ECP_ERROR)

        let finish_payload
        finish_payload = {
          protocol_and_referral_url: sing.protocol_and_referral_url,
          sticker_url: sing.sticker_url,
          timings: timings,
        }

        if (sing.referral_url) {
          finish_payload = {
            ...finish_payload,
            referral_url: sing.referral_url,
          }
        }
        if (sing.protocolPdfBuffer) {
          const url = await getSignUrl(api_url, certificate.value, sing.protocolPdfBuffer.data,)
          if (!url) throw new Error(ModalNames.ECP_ERROR)
          finish_payload = {
            ...finish_payload,
            sign_url: url
          }
        } else throw new Error(ModalNames.ECP_ERROR)
        if (sing.konturTitleData) {
          const { eventId, titleId, bufferData } = sing.konturTitleData
          const url = await getSignUrl(api_url, certificate.value, bufferData.data)
          if (!url) throw new Error(ModalNames.TITLE_ERROR)
            finish_payload = {
            ...finish_payload,
            konturTitleData: {
              eventId: eventId,
              titleId: titleId,
              signId: url.split('/').reverse()[0]
            }
          }
        }

        const finish_response = await finishCardRequest(api_url, card?.id!, finish_payload)
        if (!finish_response) throw new Error(ModalNames.ECP_ERROR)
        return ModalNames.SUCCESS

    } catch (e: any) {
        if (!!card) {
          if (e.message as ModalNames === ModalNames.TITLE_ERROR) {
            await updateCard(api_url, card.id!, { status: MedCardStatuses.FINISHED })
            return ModalNames.SUCCESS
          } else if (e.message as ModalNames === ModalNames.ECP_ERROR) {
            await updateCard(api_url, card.id!, {
              status: MedCardStatuses.FINISHED,
              medical_report: {
                medicId: medicId,
                status: IReportStatus.ABORTED,
                comment: `Ошибка при формировании ${e.message as ModalNames === ModalNames.TITLE_ERROR ? 'титулов' : 'подписи'}.`
              }
            })
          }
        }
        return e.message as ModalNames
    }
}




export const useMedsPageModel = () => {
    const [isDefectOpen, setDefectOpen] = useState(false);
    const [isDeclineOpen, setDeclineOpen] = useState(false);
    const [isDeclineIdentOpen, setDeclineIdentOpen] = useState(false);
    const dispatch = useAppDispatch();
    const { card, norms, identCard, base64FileString } = useAppSelector(state => state.examReducer)
    const { medic, isActive } = useAppSelector(state => state.mainReducer)
    const { employeeUser, currentApiUrl, originUrl } = useAppSelector(state => state.appReducer)
    const [aiResponse, setAiResponse] = useState<any>()

    const [driverData, setDriverData] = useState<IDriver | null | undefined>(null)


    const { addModal, removeModal, changeCurrentModal } = useModal()

    const [videoSrc, setVideoSrc] = useState<any>()

    const [isRequest, setRequest] = useState<boolean>(false)
    const [isAxiosError, setError] = useState<boolean>(false)
    const [isAxiosComplete, setComplete] = useState<boolean>(false)

    //const [isSubscribed, setSubscribed] = useState<boolean>(false)
    const [cardType, setCardType] = useState<CardType>(CardType.LOADING)
    const [isPenalty, setIsPenalty] = useState<boolean>(false)

    const sound = new Audio(require('./assets/audio/medexam.mp3'))
    useEffect(() => {
      if (isActive && Boolean(currentApiUrl)) { sound.play() }
    }, [currentApiUrl])

    useEffect(() => {
        if (card === null && identCard === null && currentApiUrl === undefined) return;
        const resetCards = async () => {
            if (card !== null && currentApiUrl !== undefined) {
                // updateCard(currentApiUrl, card.id!, { status: MedCardStatuses.CREATED, currentMedicId: null });
            }
            if (identCard !== null && currentApiUrl !== undefined) {
                updateDriverDocument(currentApiUrl, { id: identCard.id, status: IdentCardStatus.WAITING, medicId: null });
            }
        }
        window.addEventListener('beforeunload', resetCards)
        return () => {
            window.removeEventListener('beforeunload', resetCards)
        }
    }, [currentApiUrl, card, identCard, cardType])

    const subscribeOnMedCard = async () => {
      if (currentApiUrl && card) {
        clearTimeout(timeoutRef.current)
        // try {
          setCardType(CardType.LOADING)
          // await updateCard(currentApiUrl, Number(card?.id), {
          //   status: MedCardStatuses.PROCESSING, currentMedicId: medic.id, expiresAt: moment().add(120, "seconds").toISOString()
          // })
          const cardData = (await getMedicCardRequest(currentApiUrl, Number(card?.cardQueueId), Number(medic.id)))?.data

          if (cardData?.full_url) {
            if (cardData.full_url?.slice(-4) !== '.bin') {
              setVideoSrc('loading')
              getVideoBlobSrc(cardData?.full_url).then((result:any) => setVideoSrc(result))
            } else {
              setVideoSrc(cardData?.full_url)
            }
          } else {
            setVideoSrc(null)
          }
          if (cardData?.faceProcessingServiceTaskId && cardData.fullSrc?.slice(-4) !== '.bin') {
            getTaskResult(currentApiUrl, cardData?.faceProcessingServiceTaskId)
          }
          dispatch(setMedCardInfo({
            ...cardData,
            timings: { timingsMedic: { timezoneOffsetMin: moment().utcOffset(), ntpSync: false, considerationStartedAt: moment().format('YYYY-MM-DDTHH:mm:ss') + 'Z' } }
          }))
          dispatch(setCardTimeProgress(0))
          setCardType(CardType.MEDICAL)
        // } catch (e) {
        //   console.log(e)
        //   await resetMedCard()
        // }
      }
    }
    
    const resetMedCard = async () => {
      if (currentApiUrl && card) {
        setCardType(CardType.NONE)
        setIsPenalty(true)
        // updateCard(currentApiUrl, Number(card?.id), {
        //   status: MedCardStatuses.CREATED, currentMedicId: null, ignoredById: medic.id, expiresAt: moment().add(3, "seconds").toISOString()
        // })
        setTimeout(() => {
          setAiResponse(null)
          dispatch(setCurrentApiUrl(null))
          dispatch(setMedCardInfo(null))
          setIsPenalty(false)
        }, 5000)
      }
    }

    const subscribeOnIdentCard = async (api_url: string, identCard: any) => {
        setCardType(CardType.LOADING)

        const updatedCard = await updateDriverDocument(api_url, { id: identCard.id, status: IdentCardStatus.BUSY, medicId: medic.id });
        console.log(updatedCard)
        dispatch(setCurrentApiUrl(api_url))
        dispatch(setIdentCardInfo(updatedCard))
        dispatch(setCardTimeProgress(0))

        //setSubscribed((prevState)=>prevState=false)
        setCardType(CardType.IDENTIFICATION)
    }

    const isActiveRef = useRef(isActive)
    isActiveRef.current = isActive
    const timeoutRef = useRef<any>()
    useEffect(()=>{return () => {clearTimeout(timeoutRef.current)} },[])
    // Либо писать интервалы в useEffect'ах, либо обновлять значение через useRef и очищать интервал при размонтировании компонента useEffect return.

    // const checkCards = async () => {
    //   let medCard: { value: IMedCard, api_url: string } | undefined
    //   let identCard: { value: IdentCard, api_url: string } | undefined
    //   const medCards: { value: IMedCard, api_url: string }[] = []
    //   const identCards: { value: IdentCard, api_url: string }[] = []
    //   /* TODO: remove */
    //   const api_url = employeeUser?.roles[0]?.role?.product?.ProductParametrs?.find((e: any) => e?.api_url?.includes('test2-company-api'))?.api_url?.slice(0, -3)
    //   if (api_url && sanitizedConfig.REACT_APP_DRIVERS) {
    //     const driverCard = await getCardByDriver(api_url, sanitizedConfig.REACT_APP_DRIVERS)
    //     if (driverCard?.data) {
    //       subscribeOnMedCard(api_url, driverCard.data)
    //       return true
    //     }
    //   }
    //   //
    //   await Promise.all(
    //     employeeUser.roles[0].role.product.ProductParametrs.map(async (param: any) => {
    //       const api_url = param.api_url.slice(0, -3)
    //       const medCard = await getCard(api_url)
    //       if (medCard) { medCards.push({ value: medCard, api_url: api_url }) }
    //       // const identCard = await getDriversDocuments(api_url)
    //       // if (identCard) { identCards.push({ value: identCard, api_url: api_url }) }
    //     })
    //   )
    //   if (medCards.length > 0) {
    //     medCard = medCards.reduce((prev, curr) => {
    //       return new Date(curr.value.createdAt!).getTime() < new Date(prev.value.createdAt!).getTime() ? curr : prev
    //     }, medCards[0])
    //   }
    //   if (identCards.length > 0) {
    //     identCard = identCards.reduce((prev, curr) => {
    //       return new Date(curr.value.createdAt!).getTime() < new Date(prev.value.createdAt!).getTime() ? curr : prev
    //     }, identCards[0])
    //   }
    //   if (medCard && identCard) {
    //     if (new Date(medCard.value.createdAt!).getTime() < new Date(identCard.value.createdAt!).getTime()) {
    //         subscribeOnMedCard(medCard.api_url, medCard.value)
    //     } else {
    //         subscribeOnIdentCard(identCard.api_url, identCard.value)
    //     }
    //     return true // clearInterval(timerId)
    //   } else if (medCard) {
    //     subscribeOnMedCard(medCard.api_url, medCard.value)
    //     return true // clearInterval(timerId)
    //   } else if (identCard) {
    //     subscribeOnIdentCard(identCard.api_url, identCard.value)
    //     return true // clearInterval(timerId)
    //   } else {
    //     setCardType(CardType.NONE)
    //     return false
    //   }
    // }
    // const subscribeOnCards = async () => {
    //     if (!isActiveRef.current) {
    //       return
    //     } else {
    //     const result = await checkCards()
    //     if (!result) {
    //       timeoutRef.current = setTimeout(() => {
    //         subscribeOnCards()
    //       }, 10000)
    //     }
    //   }
    // }

    const hasCardRef = useRef<any>(false)
    const subscribeOnCards = async () => {
        // clearTimeout(timeoutTaskRef.current)
        hasCardRef.current = false
        if (!isActiveRef.current) {
          return
        } else {
          setMedicWorkStatusRequest(medic.id!, { free: true })
          setCardType(CardType.NONE)
          const result = await getCard(Number(medic.id))
          if (!result) {
            timeoutRef.current = setTimeout(() => {
              subscribeOnCards()
            }, 3000)
          } else {
            clearTimeout(timeoutRef.current)
            setMedicWorkStatusRequest(medic.id!, { free: false })
            const api_url = `${originUrl}/${result.companyPrefix}-company-api`
            // const card = await getCardRequest(api_url, result.cardId)
            dispatch(setCurrentApiUrl(api_url))
            dispatch(setMedCardInfo({
              id: result.cardId,
              cardQueueId: result.id,
              driver: { driverName: result.driverName },
              createdAt: result.cardCreatedAt,
            }))
            hasCardRef.current = true
          }
        }
    }

    const timeoutCardCountRef = useRef<any>()
    const updateCardCount = async () => {
      if (!isActiveRef.current) {
        return
      } else {
        await getCardsCount().then((response) => { dispatch(setCardsCount(response.data.count)) })
        timeoutCardCountRef.current = setTimeout(() => {
          updateCardCount()
        }, 3000)
      }
    }
    useEffect(() => {
      if (isActive) {
        updateCardCount()
      } else {
        clearTimeout(timeoutCardCountRef.current)
      }
      return () => {clearTimeout(timeoutCardCountRef.current)}
    }, [isActive])

    const timeoutTaskRef = useRef<any>()
    const getTaskResult = async (api_url: string, taskId: string ) => {
        if (!isActiveRef.current && !hasCardRef.current) {
          return
        } else {
        const result = await getFaceProcessingTask(api_url, taskId)
        if (result?.data?.data === false) {
          timeoutTaskRef.current = setTimeout(() => {
            getTaskResult(api_url, taskId)
          }, 2000)
        } else {
          setAiResponse(result.data.data)
          clearTimeout(timeoutTaskRef.current)
        }
      }
    }


    const resetCardStatus = async () => {
        if (!isActive) {
          await setMedicWorkStatusRequest(medic.id!, { free: false })
            if (card !== null && currentApiUrl !== undefined) {
                // await updateCard(currentApiUrl, card.id!, {status: MedCardStatuses.CREATED, currentMedicId: null });
                dispatch(setCurrentApiUrl(undefined))
                dispatch(setMedCardInfo(null))
                dispatch(setCardTimeProgress(0))
                setDriverData(null)
                dispatch(setDeviations(null))
                setAiResponse(null)
                //setSubscribed((prevState)=>prevState=false)
                setCardType(CardType.LOADING)
            }
            if (identCard !== null && currentApiUrl !== undefined) {
                const updatedCard = await updateDriverDocument(currentApiUrl, { id: identCard.id, status: IdentCardStatus.WAITING, medicId: null });
                dispatch(setCurrentApiUrl(undefined))
                dispatch(setIdentCardInfo(null))
                dispatch(setCardTimeProgress(0))
                setDriverData(null)

                //setSubscribed((prevState)=>prevState=false)
                setCardType(CardType.LOADING)

            }
        }
    }


    const setErrorModal = (state: boolean) => {
        setError((prevState) => prevState = state)
    }
    const setOnRequestModal = (state: boolean) => {
        setRequest((prevState) => prevState = state)
    }
    const setCompleteModal = (state: boolean) => {
        setComplete((prevState) => prevState = state)
    }
    // const setSubscribedModal=(state:boolean)=>{
    //     setSubscribed((prevState)=>prevState=state)
    // }

    const getCard = async (medicId: number) => {
        let responsedData;
        try {
            const response = await getCardForMedicRequest(medicId)
            console.log('CARD', response)
            responsedData = response.data;
            return responsedData;
        } catch (e) {

        }
    }



    
    const getDriversDocuments = async (api_url: string) => {
        try {
            const response = await getDocumentForMedicRequest(api_url);
            // const rsp = await getDocumentsRequest();
            // console.log(rsp)
            console.log('IDENTIFICATION', response)
            const responsedData = response.data;
            return responsedData;
        } catch (e) {
            console.log(e)
        }
    }

    const updateDriverDocument = async (api_url: string, data: IdentCard) => {
        try {
            const response = await updateDocumentRequest(api_url, data)
            console.log('updated response')
            console.log(response)
            const updatedData = response.data;
            return updatedData;
        } catch (e) {
            console.log(e)
        }
    }




    const approve = async () => {
        let medicalReport:IMedicalReport | null = null;

        if(!!medic){
            if(!!medic.id){
                medicalReport = {
                    status: IReportStatus.ACCEPTED,
                    medicId:medic.id,
                }
                dispatch(setMedicalReport(medicalReport))
                changeCurrentModal(ModalNames.CERTIFICATES)
                dispatch(setBase64File(undefined))
            
            }
           
        }
          



    }

    //TODO: подтвердить идентификацию.
    const approveIdent = () => {
        //setOnRequestModal(true)
        try {
          if (identCard !== null && currentApiUrl !== undefined) {
            updateDriverDocument(currentApiUrl, {
                id: identCard !== null ? identCard.id : null,
                medicId: medic?.id,
                status: IdentCardStatus.CONFIRMED
            })
            setRequest((prevState) => prevState = false)
            //setCompleteModal(true)
            dispatch(setCurrentApiUrl(undefined))
            dispatch(setIdentCardInfo(null))
            changeCurrentModal(ModalNames.SUCCESSIDENT)
            //window.alert('Водитель допущен')
          }
        } catch (e) {
            //setOnRequestModal(true)
            //setErrorModal(true)
            //window.alert('Ошибка')
        }
    }



    const getNorms = async (api_url: string) => {
        try {
            const response = await getNormsRequest(api_url);
            console.log('norms')
            console.log(response)
            dispatch(setNorms(response.data))
        } catch (e) {

        }
    }



    useEffect(() => {
      if (currentApiUrl) {
        getNorms(currentApiUrl)
      }
    }, [currentApiUrl])


    // const getDeviations = async () => {
    //     try {
    //         const response = await getDeviationsRequest();
    //         console.log('DEVIATIONS')
    //         console.log(response)
    //         dispatch(setDeviations(response.data));
    //     } catch (e) {

    //     }
    // }

    // const getDefects = async () => {
    //     try {
    //         const response = await getDefectsRequest();
    //         console.log('DEFECTS')
    //         console.log(response)
    //         dispatch(setDefects(response.data));
    //     } catch (e) {

    //     }


    // }



    useEffect(() => {
        console.log('redux cards')
        console.log(card)
        if (isActive && (card === null && identCard === null)) {
            setDefectOpen(false)
            setDeclineOpen(false)
            setCardType(CardType.NONE)
            setAiResponse(null)
            subscribeOnCards()
        } else {
            setDriverData(card?.driver)
            resetCardStatus()
        }
    }, [card, identCard, isActive])



    const toggleDefectDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
        setDefectOpen(open);
    };

    const toggleDeclineDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
        setDeclineOpen(open);
    };

    const toggleDeclineIdentDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
        setDeclineIdentOpen(open);
    };





    const normTableData: INormTable | null = !!norms && norms !== null ? {
        systolicPressure: norms.find((element: INorm) => {
            return element.code === NormCodes.SYSTOLIC
        }),
        diastolicPressure: norms.find((element: any) => {
            return element.code === NormCodes.DIASTOLIC
        }),
        pulse: norms.find((element: any) => {
            return element.code === NormCodes.PULSE
        }),
        temperature: norms.find((element: any) => {
            return element.code === NormCodes.TEMPERATURE
        }),
        alcohol: norms.find((element: any) => {
            return element.code === NormCodes.ALCOHOL
        }),
    } : null



    return {
        isDefectOpen,
        isDeclineOpen,
        isDeclineIdentOpen,
        toggleDefectDrawer,
        toggleDeclineDrawer,
        toggleDeclineIdentDrawer,
        card,
        identCard,
        driverData,
        tableMedData: getTableDataFromCard(card),
        approve,
        approveIdent,
        normTableData,

        cardType,
        isActive,

        aiResponse,

        subscribeOnMedCard,
        resetMedCard,
        isPenalty,
        videoSrc,
    }
}